import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';

import { saveAccountComments } from 'actions';

class AccountCommentsSection extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    accountId: PropTypes.number,
    storeAccount: PropTypes.shape(),
    isSavingAccount: PropTypes.bool,
    newComment: PropTypes.string
  };

  static defaultProps = {
    permissions: null,
    accountId: null,
    storeAccount: null,
    isSavingAccount: false,
    newComment: null
  };

  constructor(props) {
    super(props);

    this.state = {
      newComment: ''
    };
  }

  onNewCommentChange = e => this.setState({ newComment: e.target.value });

  onCopyComment = (comment) => {
    this.setState({ newComment: comment.comm });
  };

  onFormSubmit = () => {
    const { dispatch, accountId } = this.props;
    const { newComment } = this.state;

    dispatch(saveAccountComments(accountId, newComment));
    this.setState({ newComment: '' });
  };

  canComment() {
    const { permissions } = this.props;
    return AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit]);
  }

  render() {
    const { isSavingAccount, storeAccount: { previousComments } } = this.props;
    const { newComment } = this.state;
    const canComment = this.canComment();

    return (
      <div className="no-shrink columns">
        <div className="col-4 col-sm-12">
          <h2><strong>Account Commentary </strong></h2>
          <p>Provide any relevant information in the box below.</p>
          <textarea
            id="reviewer-comments"
            name="reviewerComment"
            { ... { rows: '10', maxLength: '2000' } }
            className="form-input"
            disabled={ !canComment }
            value={ newComment }
            onChange={ (e, value) => this.onNewCommentChange(e, value) }
          />
          <button
            id="save-comments"
            type="button"
            className="btn btn-primary mt-10 col-2"
            disabled={ isSavingAccount || !canComment }
            onClick={ () => this.onFormSubmit() }
          >
            { isSavingAccount && <span className="icon loading mr" /> }
            Save
          </button>
        </div>
        <div className="col-8 col-sm-12 reviewer-comments">
          <div className="account-comments-content">
            <div className="previous-comments col-11">
              <label htmlFor="previous-comments" className="form-label"><strong>Previous Comments</strong></label>
              <div className="comment-list">
                { (!previousComments || previousComments.length === 0) && <span>No comments made.</span> }
                { /* eslint-disable react/no-array-index-key */
                previousComments && previousComments.length > 0 && previousComments.map((comm, index) => comm != null && <p key={ index }>
                  { canComment && <button
                    className="btn btn-sm copy-icon"
                    type="button"
                    title="Copy comment"
                    onClick={ () => this.onCopyComment({ comm }) }
                  >
                    <span className="icon icon-copy" />
                  </button> }
                  {
                    comm != null && comm.split('\n') && comm.split('\n').map((item, lineIndex) => item != null && <span key={ lineIndex }>{ item }<br /></span>)
                  }</p>)
                  /* eslint-enable react/no-array-index-key */
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: {
      permissions
    },
    account: {
      isSavingAccount,
      storeAccount
    }
  } = state;

  return {
    permissions,
    isSavingAccount,
    storeAccount
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export const AccountComments = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountCommentsSection);

export default AccountComments;
